<template>
  <div :class="{ 'mobile-bg': isMobile }">
    <SEOHead :title="seoData.title" :description="seoData.description" :keywords="seoData.keywords"
      :structured-data="seoData.structuredData" />
    <HomePC v-if="!isMobile" />
    <HomeMobile v-else />
  </div>
</template>

<script>
import HomePC from './HomePC.vue'
import HomeMobile from './HomeMobile.vue'
import SEOHead from '@/components/SEOHead.vue'
import responsive from '@/utils/responsive'

export default {
  components: { HomePC, HomeMobile, SEOHead },
  data() {
    return {
      responsive,
      seoData: {
        title: '湖北智寰科技官网 - 七鼠智服AI智能客服系统 | 电商客服解决方案专家',
        description: '湖北智寰科技专注AI智能客服系统研发，七鼠智服基于千亿大模型，为电商企业提供智能客服解决方案。支持图像识别、语音解析、多平台管理，助力企业降本增效，提升客户满意度。',
        keywords: '湖北智寰科技,智寰科技官网,七鼠智服,七鼠智服官网,AI智能客服,电商客服系统,人工智能客服,智能客服解决方案,电商服务,客服机器人,AI大模型,智能营销,华中地区,武汉,深度学习',
        structuredData: {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "智寰科技首页",
          "description": "智寰科技专注AI智能客服系统研发，七鼠智服基于千亿大模型，为电商企业提供智能客服解决方案。",
          "url": "https://zhihuanai.com",
          "mainEntity": {
            "@type": "Organization",
            "name": "湖北智寰科技",
            "alternateName": ["智寰科技", "七鼠智服"],
            "description": "专注人工智能核心技术研发与应用，致力于助力企业智能化升级",
            "foundingDate": "2020",
            "industry": "人工智能",
            "areaServed": ["中国", "湖北", "华中地区", "武汉"],
            "knowsAbout": ["人工智能", "智能客服", "电商服务", "AI大模型", "客服机器人", "深度学习", "自然语言处理"],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "AI智能客服解决方案",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "SoftwareApplication",
                    "name": "七鼠智服",
                    "description": "基于千亿大模型的AI智能客服系统",
                    "applicationCategory": "客服软件",
                    "operatingSystem": "Web, Windows, iOS, Android",
                    "offers": {
                      "@type": "Offer",
                      "description": "接入AI大模型的智能客服系统，通全平台、懂产品、会营销多维赋能电商"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.responsive.isMobile
    }
  }
}
</script>

<style scoped>
.page-content {
  text-align: center;
}

/* 移动端背景色 */
.mobile-bg {
  background-color: #F5F7FB;
}
</style>